import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StarIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${Spacing.S6};
  border-radius: 50%;
  background-color: ${Color.Grey950};
`
